/**
 * Display formatters shared across the lead detail components.
 * Kept tiny on purpose — promote to a top-level `lib/` only if a non-leads
 * consumer needs them.
 */

export function formatDateTime(d: Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d)
}

export function formatPrice(p: number): string {
  return new Intl.NumberFormat('en-EU', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(p)
}

export function shortLeadId(id: string): string {
  // UUIDv4 mints from `crypto.randomUUID()` look like a wall of hex; the
  // breadcrumb mockup uses a short suffix marker for orientation. First 8
  // chars of the brand are unique enough across a single pipeline view.
  return id.length > 12 ? `${id.slice(0, 8).toUpperCase()}` : id.toUpperCase()
}
